module.exports = __webpack_public_path__ + "static/media/sur_abajo.5d203208.jpg";